import { render, staticRenderFns } from "./SkeletonCustomerDetailComponent.vue?vue&type=template&id=0f7ddfb3&"
import script from "./SkeletonCustomerDetailComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonCustomerDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports